(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.querySelector('.banner-carousel-section');
  var slides = carousel.querySelectorAll('.banner-slide');
  var prevButton = carousel.querySelector('.banner-prev');
  var nextButton = carousel.querySelector('.banner-next');
  var currentSlide = 0;
  var transitionType = carousel.dataset.transition;
  var autoplaySpeed = parseInt(carousel.dataset.autoplay);
  var autoplayInterval;

  function setAspectRatio() {
    var desktopHeight = parseInt(carousel.dataset.desktopHeight);
    var mobileHeight = parseInt(carousel.dataset.mobileHeight);
    var margin = parseInt(carousel.dataset.margin);
    var width = carousel.offsetWidth;
    var height;
    var aspectRatio;

    if (window.innerWidth <= 767) {
      height = mobileHeight;
      aspectRatio = 9 / 18;
    } else {
      height = desktopHeight;
      aspectRatio = 21 / 9;
    }

    carousel.style.height = height + 'px';
    
    slides.forEach(function(slide) {
      slide.style.height = height + 'px';
      
      var videoContainer = slide.querySelector('.banner-video-container');
      if (videoContainer) {
        var videoAspectRatio = window.innerWidth <= 767 ? 9 / 16 : 16 / 9;
        var videoWidth = height * videoAspectRatio;
        var videoHeight = height;
        
        if (videoWidth < width) {
          videoWidth = width;
          videoHeight = width / videoAspectRatio;
        }
        
        videoContainer.style.width = videoWidth + 'px';
        videoContainer.style.height = videoHeight + 'px';
      }
    });
  }

  function showSlide(n) {
    slides[currentSlide].classList.remove('active');
    currentSlide = (n + slides.length) % slides.length;
    slides[currentSlide].classList.add('active');
  }

  function nextSlide() {
    showSlide(currentSlide + 1);
  }

  function prevSlide() {
    showSlide(currentSlide - 1);
  }

  function startAutoplay() {
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  setAspectRatio();
  window.addEventListener('resize', setAspectRatio);

  showSlide(0);
  startAutoplay();

  prevButton.addEventListener('click', function() {
    prevSlide();
    stopAutoplay();
    startAutoplay();
  });

  nextButton.addEventListener('click', function() {
    nextSlide();
    stopAutoplay();
    startAutoplay();
  });

  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
// Add your JavaScript here if needed.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
  const zodokCategoryleftButton = document.querySelector(".zodok-featured-collection-button-previous");
  const zodokCategoryrightButton = document.querySelector(".zodok-featured-collection-button-next");
  const zodokCategorylist = document.querySelector(".zodok-featured-collection-list");
  const zodokCategoryitem = document.querySelector(".zodok-featured-collection-list li");

  let zodokCategoryitemWidth = zodokCategoryitem.offsetWidth;

  zodokCategoryrightButton.addEventListener("click", () => {scrollCategory("right")});
  zodokCategoryleftButton.addEventListener("click", () => {scrollCategory("left")});

  function scrollCategory(direction) {
    if(direction === "left") {
        zodokCategorylist.scrollBy({left: -zodokCategoryitemWidth, behavior: "smooth"});
    } else {
        zodokCategorylist.scrollBy({left: zodokCategoryitemWidth, behavior: "smooth"});
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      const button = document.querySelector(".zodok-fixed-button");
      if(button != null)
        button.style.top = 16 + "px";
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      const button = document.querySelector(".zodok-fixed-button");
      if(button != null)
        button.style.top = 16 + this.header.offsetHeight + "px";
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodok-categories"] && !Shopify.designMode) return;
  try {
    
  const zodokCollectionItems =  document.querySelectorAll(".zodok-category");

  if(zodokCollectionItems.length >= 11)
  {
    if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 767) {
      zodokCollectionItems[10].style.display = "block";
       if(zodokCollectionItems.length >= 12)
         zodokCollectionItems[11].style.display = "none";
    }
    else if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 912) {
      zodokCollectionItems[10].style.display = "none";
      if(zodokCollectionItems.length >= 12)
        zodokCollectionItems[11].style.display = "none";
      } else {
        zodokCollectionItems[10].style.display = "block";
        if(zodokCollectionItems.length >= 12)
          zodokCollectionItems[11].style.display = "block";
    }

    window.onresize = () => {
      if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 767) {
        zodokCollectionItems[10].style.display = "block";
        if(zodokCollectionItems.length >= 12)
          zodokCollectionItems[11].style.display = "none";
      }
      else if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 912) {
        zodokCollectionItems[10].style.display = "none";
        if(zodokCollectionItems.length >= 12)
          zodokCollectionItems[11].style.display = "none";
      } else {
        zodokCollectionItems[10].style.display = "block";
        if(zodokCollectionItems.length >= 12)
          zodokCollectionItems[11].style.display = "block";
      }
    }
  }

  if(zodokCollectionItems.length >= 7)
  {
    if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 767){
      zodokCollectionItems[7].style.display = "block";
      zodokCollectionItems[6].style.display = "block";
    }
    else if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 912) {
      zodokCollectionItems[7].style.display = "none";
      zodokCollectionItems[6].style.display = "none";
      } else {
        zodokCollectionItems[6].style.display = "block";
        zodokCollectionItems[7].style.display = "none";
    }

    window.onresize = () => {
        if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 767){
      zodokCollectionItems[7].style.display = "block";
      zodokCollectionItems[6].style.display = "block";
    }
      else if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 912) {
        zodokCollectionItems[7].style.display = "none";
        zodokCollectionItems[6].style.display = "none";
        } else {
          zodokCollectionItems[6].style.display = "block";
          zodokCollectionItems[7].style.display = "none";
      }
    }
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodok-caurosel-2"] && !Shopify.designMode) return;
  try {
    
  const leftButton1 = document.querySelector(".zodok-caurosel-1-button-previous");
  const rightButton1 = document.querySelector(".zodok-caurosel-1-button-next");
  const list1 = document.querySelector(".zodok-caurosel-1-list");
  const itemsStart1 = document.querySelectorAll(".zodok-caurosel-1-item-start");
  const itemsMiddle1 = document.querySelectorAll(".zodok-caurosel-1-item-middle");
  const itemsEnd1 = document.querySelectorAll(".zodok-caurosel-1-item-end");
  const scrollButtons1 = document.querySelectorAll(".zodok-caurosel-1-button");
  
  const scrollOfset = list1.scrollLeft;
  let itemWidth = itemsMiddle1[0].offsetWidth;
  let carouselWidth = itemWidth * itemsMiddle1.length;
  
  document.querySelector(".zodok-caurosel-1-wrapper").onresize = toogleScroll;
  toogleScroll();
  
  if(carouselWidth > window.innerWidth) {
      list1.scrollBy({left: (2*carouselWidth), behavior: "instant"});
  }
  
  if(isTouchDevice())
      list1.addEventListener("touchstart", snap);
  else {
      leftButton1.addEventListener("click", () => {scroll("left"); snapLeft();});
      rightButton1.addEventListener("click", () => {scroll("right"); snapRight();});
  }
  
  function scroll(direction) {
      if(direction === "left") {
          list1.scrollBy({left: -itemWidth, behavior: "smooth"});
      } else {
          list1.scrollBy({left: itemWidth, behavior: "smooth"});
      }
  }
  
  function toogleScroll() {
  
      itemWidth = itemsMiddle1[0].offsetWidth;
      carouselWidth = itemWidth * itemsMiddle1.length;
  
      if(carouselWidth <= window.innerWidth) {
  
          scrollButtons1.forEach(element => {
              element.style.display = "none";
          });
  
          itemsStart1.forEach(element => {
              element.style.display = "none";
          });
  
          itemsEnd1.forEach(element => {
              element.style.display = "none";
          });
  
          list.style.maskImage = "none";
      } else {
  
          if(!isTouchDevice()){
              scrollButtons1.forEach(element => {
                  element.style.display = "block";
              });
          } else {
              scrollButtons1.forEach(element => {
                  element.style.display = "none";
              });
          }
  
          itemsStart1.forEach(element => {
              element.style.display = "block";
          });
  
          itemsEnd1.forEach(element => {
              element.style.display = "block";
          });
  
          list1.style.maskImage = "linear-gradient(to right, rgb(0, 0, 0, 0) 0%, rgba(205, 205, 205) 20%, rgba(205, 205, 205) 80%, rgb(0, 0, 0, 0) 100%)";
      }
  }
  
  function isTouchDevice() {
      return (('ontouchstart' in window) ||
         (navigator.maxTouchPoints > 0) ||
         (navigator.msMaxTouchPoints > 0));
  }
  
  function snap() {
      if(list1.scrollLeft >= (3 * carouselWidth))
          list1.scrollBy({left: -carouselWidth, behavior: "instant"});
      else if(list.scrollLeft <= (carouselWidth))
          list1.scrollBy({left: carouselWidth, behavior: "instant"});
  }
  
  function snapLeft() {
      if(list1.scrollLeft <= (1 * itemsMiddle1[0].offsetWidth * itemsMiddle1.length)) {
          list1.scrollBy({left: (itemsMiddle1[0].offsetWidth * (itemsMiddle1.length)), behavior: "instant"});
          list1.scrollBy({left: -itemsMiddle1[0].offsetWidth, behavior: "smooth"})
      }
  }
  
  function snapRight() {
      if(list1.scrollLeft >= (3 * itemsMiddle1[0].offsetWidth * itemsMiddle1.length)) {
          list1.scrollBy({left: -(itemsMiddle1[0].offsetWidth * (itemsMiddle1.length)), behavior: "instant"});
          list1.scrollBy({left: itemsMiddle1[0].offsetWidth, behavior: "smooth"});
      }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodok-caurosel"] && !Shopify.designMode) return;
  try {
    
  const zodokCauroselleftButton = document.querySelector(".zodok-caurosel-button-previous");
  const zodokCauroselrightButton = document.querySelector(".zodok-caurosel-button-next");
  const list = document.querySelector(".zodok-caurosel-list");
  const itemsStart = document.querySelectorAll(".zodok-caurosel-item-start");
  const itemsMiddle = document.querySelectorAll(".zodok-caurosel-item-middle");
  const itemsEnd = document.querySelectorAll(".zodok-caurosel-item-end");
  const scrollButtons = document.querySelectorAll(".zodok-caurosel-button");
  
  const scrollOfset = list.scrollLeft;
  let itemWidth = itemsMiddle[0].offsetWidth;
  let carouselWidth = itemWidth * itemsMiddle.length;
  
  window.onresize = toogleScroll;
  toogleScroll();
  
  if(carouselWidth > window.innerWidth) {
      list.scrollBy({left: (2*carouselWidth), behavior: "instant"});
  }
  
  if(isTouchDevice())
      list.addEventListener("touchstart", snap);
  else {
      zodokCauroselrightButton.addEventListener("click", () => {scroll("right"); snapRight();});
      zodokCauroselleftButton.addEventListener("click", () => {scroll("left"); snapLeft();});
  }
  
  function scroll(direction) {
      if(direction === "left") {
          list.scrollBy({left: -itemWidth, behavior: "smooth"});
      } else {
          list.scrollBy({left: itemWidth, behavior: "smooth"});
      }
  }
  
  function toogleScroll() {
  
      itemWidth = itemsMiddle[0].offsetWidth;
      carouselWidth = itemWidth * itemsMiddle.length;
  
      if(carouselWidth <= window.innerWidth) {
  
          scrollButtons.forEach(element => {
              element.style.display = "none";
          });
  
          itemsStart.forEach(element => {
              element.style.display = "none";
          });
  
          itemsEnd.forEach(element => {
              element.style.display = "none";
          });
  
          list.style.maskImage = "none";
      } else {
  
          if(!isTouchDevice()){
              scrollButtons.forEach(element => {
                  element.style.display = "block";
              });
          } else {
              scrollButtons.forEach(element => {
                  element.style.display = "none";
              });
          }
  
          itemsStart.forEach(element => {
              element.style.display = "block";
          });
  
          itemsEnd.forEach(element => {
              element.style.display = "block";
          });
  
          //list.style.maskImage = "linear-gradient(to right, rgb(0, 0, 0, 0) 0%, rgba(205, 205, 205) 20%, rgba(205, 205, 205) 80%, rgb(0, 0, 0, 0) 100%)";
      }
  }
  
  function isTouchDevice() {
      return (('ontouchstart' in window) ||
         (navigator.maxTouchPoints > 0) ||
         (navigator.msMaxTouchPoints > 0));
  }
  
  function snap() {
      if(list.scrollLeft >= (3 * carouselWidth))
          list.scrollBy({left: -carouselWidth, behavior: "instant"});
      else if(list.scrollLeft <= (carouselWidth))
          list.scrollBy({left: carouselWidth, behavior: "instant"});
  }
  
  function snapLeft() {
      if(list.scrollLeft <= (1 * itemsMiddle[0].offsetWidth * itemsMiddle.length)) {
          list.scrollBy({left: (itemsMiddle[0].offsetWidth * (itemsMiddle.length)), behavior: "instant"});
          list.scrollBy({left: -itemsMiddle[0].offsetWidth, behavior: "smooth"})
      }
  }
  
  function snapRight() {
      if(list.scrollLeft >= (3 * itemsMiddle[0].offsetWidth * itemsMiddle.length)) {
          list.scrollBy({left: -(itemsMiddle[0].offsetWidth * (itemsMiddle.length)), behavior: "instant"});
          list.scrollBy({left: itemsMiddle[0].offsetWidth, behavior: "smooth"});
      }
  }

  } catch(e) { console.error(e); }
})();
})();
